import { Stack, Typography, useTheme } from "@mui/material";
import { RadioDot } from "web_myplann/Shared/Components/FlatRow/RadioDot";

export type FlatRowRadioOption<TValue extends string | number = string> = {
	value: TValue;
	label: string;
};

export type FlatRowRadioGroupProps<TValue extends string | number = string> = {
	value: TValue;
	options: FlatRowRadioOption<TValue>[];
	onChange?: (value: TValue) => void;
	onBlur?: () => void;
};

export const FlatRowRadioGroup = <TValue extends string | number = string>({
	value,
	options,
	onChange,
	onBlur,
}: FlatRowRadioGroupProps<TValue>) => {
	const theme = useTheme();

	return (
		<>
			{options.map((option, index) => (
				<Stack
					key={option.value}
					component="button"
					type="button"
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					onClick={() => onChange?.(option.value)}
					onBlur={onBlur}
					sx={{
						width: "100%",
						minHeight: 48,
						px: 2,
						appearance: "none",
						border: "none",
						cursor: "pointer",
						bgcolor: "transparent",
						borderBottom:
							index === options.length - 1
								? "none"
								: `1px solid ${theme.palette.grey[100]}`,
					}}
				>
					<Typography variant="body2">{option.label}</Typography>
					<RadioDot selected={value === option.value} />
				</Stack>
			))}
		</>
	);
};
